import React, { useEffect, useState } from 'react';
import SlickSlider from "../UI/Slick";
import LogoItem from './LogoItem'

import {useCustomersList} from './../../queries/customers';
import InfinitProgressBar from '../InfiniteProgressBar';

function BrandLogo(props) {


    
    const {error, loading, data} = useCustomersList();
    if(loading) return <InfinitProgressBar/>
    if(error) return <div>error!</div>
    

    const settings = {
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        className: "brand-logo-content",
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 401,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    return (
        <div className="brand-logo-area sm-top">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <SlickSlider settings={settings}>
                            {
                                data.customers.map(logo => (
                                    <LogoItem key={logo.id} logoSrc={logo.image.urls[0]} URL={logo.URL}/>
                                ))
                            }
                        </SlickSlider>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BrandLogo;